module.exports = __webpack_public_path__ + "fonts/Quicksand-700-latin-ext14.29b81f3.woff2";